<template>
  <v-dialog v-model="qrCodeDialog" width="300">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        color="#1d1346"
        v-bind="attrs"
        v-on="on"
        @click="loadUrl"
        class="sbp-payment__dialog-btn"
        :disabled="disabled"
      >
        <v-img src="https://cdn.vladlink.ru/banks/ru-sbp-small-original.png" max-width="30px"></v-img>
        <span style="color: white;">СБП</span>
      </v-btn>
    </template>

    <v-card>
      <v-card-title class="d-flex justify-center">QR-код для оплаты</v-card-title>
      <h4 class="d-flex justify-center align-center mb-5">
        <v-img src="https://cdn.vladlink.ru/banks/ru-sbp-small-original.png" max-width="40px"></v-img>
        <span>СБП</span>
      </h4>

      <v-card-text class="d-flex flex-column align-center sbp-payment__content">
        <v-progress-linear
          v-if="loading"
          indeterminate
        />

        <qr-code
          v-else-if="sbpUrl !== null && viewport !== 'xs' && viewport !== 'sm'"
          class="qr-code mb-5"
          :value="sbpUrl"
        />
        <v-btn
          v-else-if="sbpUrl !== null"
          class="mb-4"
          color="primary"
          :href="sbpUrl"
          target="_blank"
        >Оплатить</v-btn>
        <v-alert v-else-if="!loading" type="warning">Не удалось получить ссылку для QR-кода. Попробуйте позже.</v-alert>

        <span class="info-text">к оплате: <b>{{ this.amount }} рублей</b></span>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import QrCode from "../QR/QrCode.vue";
import axios from 'axios';

export default {
  name: "SbpPayment",
  props: {
    personalAccount: {
      type: Number,
      required: true,
    },
    amount: {
      type: Number,
      required: true,
    },
    email: {
      type: String|null,
    },
    disabled: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  components: {QrCode},
  data: () => ({
    qrCodeDialog: false,
    loading: false,
    sbpUrl: null,
  }),
  computed: {
    viewport() {
      return this.$vuetify.breakpoint.name;
    },
  },
  methods: {
    loadUrl() {
      this.loading = true;

      axios.post(
        `${process.env.SBP_REST_API}qr/pay`,
        {
          data: {
            personal_account: this.personalAccount,
            sum: this.amount,
            email: this.email,
          },
        })
        .then(response => {
          this.sbpUrl = response.data.data.link;
        }).finally(() => {
        this.loading = false;
      });
    }
  },
}
</script>

<style scoped>
.qr-code {
  border: 1px solid #1d1346;
}

.sbp-payment__content {
  color: black;
}

.info-text {
  color: black;
}

.sbp-payment__dialog-btn {
  width: 125px;
}

@media screen and (max-width: 768px) {
  .sbp-payment__dialog-btn {
    width: 100%;
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Payments/SbpPayment.vue